<div class="header-bar">
  <div class="header-left"></div>
  <div class="header-center">Select Instrument Panels to Open</div>
  <div class="header-right">
    <button
      mat-button
      color="lightGreen"
      (click)="goToView()"
      [disabled]="openDisabled"
    >
      Open Selected Panels
    </button>
  </div>
</div>

<div class="accounts-selection">
  <div
    class="account"
    *ngFor="let account of accounts"
    (click)="changeSelection(account)"
    [ngClass]="{ selected: account.selected }"
  >
    <div *ngIf="!account.logo" class="account-name">
      {{ account.accountName }}
    </div>
    <div *ngIf="account.logo" class="account-logo">
      <svg-icon
        [src]="account.logo"
        [svgStyle]="{
          'width.px': '222',
          'height.px': '150'
        }"
      ></svg-icon>
    </div>
    <mat-checkbox
      class="selection-checkbox"
      color="lightGreen"
      [(ngModel)]="account.selected"
      [disabled]="true"
    ></mat-checkbox>
  </div>
  <div class="no-accounts" *ngIf="!accounts.length">No accounts available</div>
</div>
